import React from 'react';
import { FormInputRadio } from '../../../common/formInputsV2/FormInputRadio';
import { genders } from '../../../common/constants';
import { FormInputText } from '../../../common/formInputsV2/FormInputText';
import { FormInputSelect } from '../../../common/formInputsV2/FormInputSelect';
import { FormInputDate } from '../../../common/formInputsV2/FormInputDate';
import getMinAllowedBirthday from '../../../common/helpers/getMinAllowedBirthday';
import getMaxAllowedBirthday from '../../../common/helpers/getMaxAllowedBirthday';
import FormReactSelectInputBirthPlace from '../../../common/formInputsV2/FormReactSelectInputBirthPlace';
import { FormInputAddressCompleteManual } from '../../../common/formInputsV2/FormInputAddressCompleteManual';
import { FormInputAddressComplete } from '../../../common/formInputsV2/FormInputAddressComplete';
import PaymentTypePeriod from '../../../common/formInputsV2/PaymentTypePeriod';
import InputPrivacy from '../../../common/componentsV2/inputs/InputPrivacy';
import getAllowedPolicyEffectDate from '../../../common/helpers/getAllowedPolicyEffectDate';
import { FormLayout } from '../../../common/formInputsV2/FormLayout.styles';
import { SurfaceCardHeading } from '../../../common/formInputsV2/Card.styles';

function AncillariStepThree({
  register,
  errors,
  isValid,
  formDataFlow,
  updateUserData,
  states,
  municipalities,
  formData,
  updateFormData,
  showManualAdress,
  setShowManualAdress,
  dataPrivacy,
  privacyItemChangeHandler,
  greeniaPrivacyPolicy,
  showPrivacyErrors = false,
}) {
  return (
    <FormLayout id="datiPersonali">
      <FormInputRadio
        options={genders}
        label="Il contraente è"
        name="gender"
        registration={register('gender')}
        error={errors.gender?.message}
      />
      {formDataFlow.gender === 'G' ? (
        <>
          <FormInputText
            placeholder="Ragione Sociale"
            label="Ragione Sociale"
            registration={register('business_name')}
            error={errors.business_name?.message}
            valid={isValid('business_name')}
          />
          <FormInputText
            placeholder="Partita Iva"
            label="Partita Iva"
            registration={register('vat_number')}
            error={errors.vat_number?.message}
            valid={isValid('vat_number')}
          />
          <FormInputSelect
            label="Tipologia azienda"
            registration={register('company_type')}
            error={errors.company_type?.message}
            valid={isValid('company_type')}
            placeholder="-Seleziona-"
            options={formData.company_types}
          />
        </>
      ) : (
        <>
          <FormInputText
            placeholder="Nome"
            label="Nome"
            registration={register('name')}
            error={errors.name?.message}
            valid={isValid('name')}
          />
          <FormInputText
            placeholder="Cognome"
            label="Cognome"
            registration={register('surname')}
            error={errors.surname?.message}
            valid={isValid('surname')}
          />
          <FormInputDate
            label="Data di nascita"
            registration={register('date_of_birth')}
            minDate={getMinAllowedBirthday()}
            maxDate={getMaxAllowedBirthday()}
            error={errors.date_of_birth?.message}
            valid={isValid('date_of_birth')}
          />
          <FormReactSelectInputBirthPlace
            states={states}
            options={municipalities}
            label="Luogo di nascita"
            name="commune_of_birth_code"
            values={{
              commune_of_birth_code: formDataFlow.commune_of_birth_code,
              province_of_birth_code: formDataFlow.province_of_birth_code,
              born_abroad: formDataFlow.born_abroad,
              country_of_birth_code: formDataFlow.country_of_birth_code,
            }}
            onChange={(value) => updateUserData({
              commune_of_birth_code: value.commune_of_birth_code,
              province_of_birth_code: value.province_of_birth_code,
              born_abroad: value.born_abroad,
              country_of_birth_code: value.country_of_birth_code,
            })}
            valid={isValid('commune_of_birth_code')}
            error={errors.commune_of_birth_code?.message}
            valid_country_of_birth_code={isValid('country_of_birth_code')}
            error_country_of_birth_code={errors.country_of_birth_code?.message}
          />
        </>
      )}

      <FormInputText
        registration={register('email')}
        label="E-mail"
        placeholder="nome@esempio.it"
        error={errors.email?.message}
        valid={isValid('email')}
      />
      <FormInputText
        registration={register('phone')}
        label="Phone"
        placeholder="Es. 3401234567"
        paragraph="Numeri di rete fissa non accettati dalle aziende"
        error={errors.phone?.message}
        valid={isValid('phone')}
      />
      {showManualAdress ? (
        <FormInputAddressCompleteManual
          municipalities={municipalities}
          formData={formDataFlow}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
        />
      ) : (
        <FormInputAddressComplete
          municipalities={municipalities}
          formData={formDataFlow}
          isValid={isValid}
          errors={errors}
          register={register}
          updateFormData={updateFormData}
          addressId="autocomplete-address-contractor"
          setShow={setShowManualAdress}
        />
      )}

      <FormInputDate
        label="Data Decorrenza"
        registration={register('policy_effective_date')}
        error={errors.policy_effective_date?.message}
        valid={isValid('policy_effective_date')}
        minDate={getAllowedPolicyEffectDate('min')}
      />

      <div className="periodicitaDeiPagamenti">
        <PaymentTypePeriod
          selectedType={formDataFlow.payment_frequency}
          updateAnswers={updateFormData}
          error={errors.payment_frequency?.message}
        />
      </div>

      <div className="terms">
        <SurfaceCardHeading>Informativa Privacy e IVASS</SurfaceCardHeading>

        <div className="text-decoration-underline mt-1 mb-2">
          <a
            onClick={() => greeniaPrivacyPolicy()}
            style={{ cursor: 'pointer' }}
          >
            <small>Greenia Privacy Policy</small>
          </a>
        </div>
        {dataPrivacy.map((item, i) => (
          <InputPrivacy
            required={item.required}
            label={item.content}
            name={item.type}
            id={item.type}
            key={i}
            checked={formDataFlow?.privacies.includes(item.id)}
            hasError={showPrivacyErrors && item.required === 1 && !formDataFlow?.privacies.includes(item.id)}
            onChange={(value) => privacyItemChangeHandler(value, item)}
          />
        ))}
      </div>
    </FormLayout>
  );
}

export default AncillariStepThree;
